import { render, staticRenderFns } from "./CallList.vue?vue&type=template&id=4eef4bf7&scoped=true&"
import script from "./CallList.vue?vue&type=script&lang=js&"
export * from "./CallList.vue?vue&type=script&lang=js&"
import style0 from "./CallList.vue?vue&type=style&index=0&id=4eef4bf7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eef4bf7",
  null
  
)

export default component.exports